export default __webpack_public_path__ + "static/media/emptyIcon.3dab95f7.svg";